/** Ported from Clarity `apps/web/src/shared/ui/SidePanel.tsx` (commit `f9217bb5a`). */
/**
 * The element that has focus, or `null` for anything that is not an `HTMLElement` (an SVG node, or no
 * focus at all) — brain's `instanceof HTMLElement` check before it remembers a restore target
 * (`SidePanel.tsx:225-230`).
 */
export function activeHtmlElement(document: Document): HTMLElement | null {
	const active = document.activeElement;

	return active instanceof HTMLElement ? active : null;
}
